import type { Button } from '~/types'

export function getImagePath(record: { collectionId: string, id: string, src: string, direct?: boolean }, thumb?: string) {
  const { pbUrl } = useRuntimeConfig().public
  const { collectionId, id, src } = record
  const path = `${collectionId}/${id}/${src}`

  // Strip trailing slash from pbUrl (if it exists) to prevent double slashes
  const cleanBaseUrl = pbUrl.replace(/\/$/, '')

  let url = `${cleanBaseUrl}/api/files/${path}`
  if (thumb) {
    url += `?thumb=${thumb}`
  }
  return url
}

export function getLinkFromButton(button: Button) {
  if (button?.expand?.page?.slug) {
    return `${button.expand.page.slug}`
  }
  return button?.href ?? '/'
}

export function getButton(button: Button) {
  return {
    target: getTarget(button),
    title: button.title,
    to: button?.to ?? getLinkFromButton(button)
  }
}

function getTarget(button: Button) {
  if (button.href) {
    return '_blank'
  }
  return '_self'
}
